<template>
  <div class="page-wrapper">
    <h2 v-if="configData?.Header" class="heading-xxs mb-10 lg:mb-24">
      {{ configData.Header }}
    </h2>
    <div class="gap-16 grid grid-cols-1 lg:grid-cols-3">
      <NuxtLink
        v-for="card in configData?.Cards || []"
        :key="card.Url || ''"
        :to="card.Url || ''"
        external
        :class="[
          'p-16',
          'border-md',
          'border-border-tertiary',
          'rounded-md',
          'bg-surface-action-2',
          'hover:bg-surface-action-hover',
          'flex',
          'flex-row',
          'justify-between',
          'items-center',
          'no-underline',
        ]"
      >
        <div class="flex flex-row items-center">
          <NuxtImg
            v-if="card.Icon === 'subscription-100'"
            src="/images/subscriptions/100_small.svg"
            alt=""
            class="mr-8 lg:mr-16 w-24 h-24"
            provider="cloudfront"
          />
          <nuxt-icon
            v-else-if="card.Icon"
            class="text-text-primary mr-8 lg:mr-16 text-24"
            :name="card.Icon"
            :filled="false"
          />
          <span v-if="card.Label" class="heading-xs">{{ card.Label }}</span>
        </div>
        <nuxt-icon
          class="text-text-primary text-24"
          name="arrow-right"
          :filled="false"
        />
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
interface CTALinkCard {
  Label?: string;
  Url?: string;
  Icon?: string;
}

interface Props {
  configData: {
    Header?: string;
    Cards: CTALinkCard[];
  };
}
defineProps<Props>();
</script>
